export default "__VITE_ASSET__DRDWnpAu__"